// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2su85","title":"Header_title__3_0r7","left":"Header_left__21ubG","clinicName":"Header_clinicName__23aJk"};